import { render } from "./estatisticas.vue?vue&type=template&id=3c97c3fe&scoped=true"
import script from "./estatisticas.vue?vue&type=script&lang=js"
export * from "./estatisticas.vue?vue&type=script&lang=js"

import "./estatisticas.vue?vue&type=style&index=0&id=3c97c3fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c97c3fe"]])

export default __exports__